
import { requestAPI } from '../utils/common'

let text = (data) => {
  return requestAPI('city/price/list', data)
}
let checkStatus = (data) => {
  return requestAPI('/oapi/driver/signup/checkstatus', data)
}
let createVerifycode = (data) => {
  return requestAPI('/oapi/driver/signup/createverifycode', data)
}
let checkVerifycode = (data) => {
  return requestAPI('/oapi/driver/signup/checkverifycode', data)
}
let getCityOpen = (data) => {
  return requestAPI('oapi/driver/signup/cityopen', data)
}
let getSignUpInfo = (data) => {
  return requestAPI('/oapi/driver/signup/info', data)
}
let updateBasic = (data) => {
  return requestAPI('/oapi/driver/signup/updatebasic', data, 'POST')
}
let getOriganizationList = (data) => {
  return requestAPI('/oapi/common/organization', data)
}
let getExam = (data) => {
  return requestAPI('/oapi/driver/signup/exam', data)
}
let getExamResult = (data) => {
  return requestAPI('/oapi/driver/signup/examcheck', data, 'POST')
}
let uploadPic = (data) => {
  return requestAPI('/oapi/driver/signup/upload', data, 'POST')
}
let wxConfig = (data) => {
  return requestAPI('/oapi/driver/signup/getwechatsignature', data, 'POST')
}
let updateTshirt = (data) => {
  return requestAPI('/oapi/driver/signup/update_tshirt', data, 'POST')
}
let getOpenid = (data) => {
  return requestAPI('/oapi/driver/signup/getopenid', data, 'POST')
}
let roadbookingList = (data) => {
  return requestAPI('/oapi/driver/signup/roadbookinglist', data, 'POST')
}
let driverBooking = (data) => {
  return requestAPI('/oapi/driver/booking/book', data, 'POST')
}
let checkCard = (data) => {
  return requestAPI('/oapi/driver/signup/checkidcard', data)
}
let checkDriverLicense = (data) => {
  return requestAPI('/oapi/driver/signup/checkdriverlicense', data)
}
let uploadExamCheck = (data) => {
  return requestAPI('/oapi/driver/signup/exampass', data, 'POST')
}
let checkInviteCode = (data) => {
  Object.assign(data, {
    service: 'ecap',
    apiMethod: 'api/invite/recuitDriverCheck'
  })
  return requestAPI('api/gateway', data, 'POST')
}
let submitInviteCode = (data) => {
  Object.assign(data, {
    service: 'ecap',
    apiMethod: 'api/invite/recuitDriverAdd'
  })
  return requestAPI('api/gateway', data, 'POST', true)
}
let submitIdCard = (data) => {
  return requestAPI('/oapi/invite/recuitDriver/addIdCard', data, 'POST')
}

let getSwitch = (data) => {
  return requestAPI('/oapi/driver/signup/switch', data)
}

let getCompanyInfo = (data) => {
  return requestAPI('/oapi/driver/signup/company_info', data)
}

// 日志收集接口
const mRequestMonitor = (data) => {
  return requestAPI('/oapi/report/requestMonitor', {
    third_request_url: 'driver-recruit-monitor',
    ...data
  }, 'POST')
}
export {
  text,
  submitIdCard,
  submitInviteCode,
  checkInviteCode,
  checkStatus,
  createVerifycode,
  checkVerifycode,
  uploadPic,
  getCityOpen,
  getSignUpInfo,
  updateBasic,
  getOriganizationList,
  getExam,
  getExamResult,
  wxConfig,
  updateTshirt,
  getOpenid,
  roadbookingList,
  driverBooking,
  checkCard,
  checkDriverLicense,
  uploadExamCheck,
  getSwitch,
  getCompanyInfo,
  mRequestMonitor
}



// WEBPACK FOOTER //
// ./src/utils/actions.js